/**
 * SO — Oscilador Estocástico.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLMomentum.cs, classe FML.SO
 * — ≠ stochastic do odin, que usa range ROLLING de N períodos; aqui o range é da
 * PRÓPRIA barra). Painel próprio, 2 linhas, escala 0–1:
 *
 *   K  = (C − L) / (H − L)      (posição do fechamento no range da barra)
 *   SK = SMA(K, N1, 1)          (SMA-chinesa = DMA(K, 1/N1, N1))
 *   SD = SMA(SK, N2, 1)
 *
 * Barras flat (H==L) → 0/0 = NaN (propaga na SMA). Paridade provada em
 * __tests__/so.silverlight.test.js.
 */
import { sub, div, sma } from "./silverlightDsl";
import { SO as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { n1, n2 } = options;
    const num = (v) => (Number.isFinite(v) ? v : NaN);
    const h = data.map((d) => num(d.high));
    const l = data.map((d) => num(d.low));
    const c = data.map((d) => num(d.close));

    const k = div(sub(c, l), sub(h, l)); // (C-L)/(H-L)
    const sk = sma(k, n1, 1);
    const sd = sma(sk, n2, 1);

    return sk.map((skv, i) => {
      const skOut = Number.isFinite(skv) ? skv : undefined;
      const sdOut = Number.isFinite(sd[i]) ? sd[i] : undefined;
      if (skOut === undefined && sdOut === undefined) return undefined;
      return { sk: skOut, sd: sdOut };
    });
  }

  calculator.undefinedLength = function () {
    const { n1, n2 } = options;
    // SK acrescenta N1-1 sobre K; SD acrescenta N2-1 sobre SK.
    return Math.max(0, n1 - 1 + (n2 - 1));
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
